<script>
export default {
    name: "ConstructionFeaturesTab",
    props:{
        construction: {required: true}
    },
    methods: {
        featuresList(features) {
            return features.map(i => i.name).join(' - ')
        },
    }
}
</script>

<template>
    <div>
        <div class="row">
            <div class="col-xg-6 col-lg-6 col-xs-12" v-if="construction.proximities.length">
                <div class="portlet light"  style="padding-top: 0;padding-bottom: 0;margin-bottom: 10px;">
                    <h4 style="margin-top:0;margin-bottom:20px"><b>Proximidades</b></h4>
                    <div class="row" style="height: 100px;overflow-y: auto">
                        <div class="col-xg-6 col-lg-6 col-xs-6" style="margin: 0 0 8px 0;" v-for="proximity in construction.proximities">
                                                    <span>
                                                        <i class="fa fa-check"></i> {{ proximity.name }}
                                                    </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xg-6 col-lg-6 col-xs-12" v-if="construction.features.length">
                <div class="portlet light"  style="padding-top: 0;padding-bottom: 0;margin-bottom: 10px;">
                    <h4 style="margin-top:0;margin-bottom:20px"><b>Características gerais</b></h4>
                    <div class="row" style="height: 100px;overflow-y: auto">
                        <div class="col-xg-6 col-lg-6 col-xs-6" style="margin: 0 0 8px 0;" v-for="feature in construction.features">
                                                    <span>
                                                        <i class="fa fa-check"></i> {{ feature.name }}
                                                    </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <hr>
        <div class="row" v-if="construction.rooms.length" style="height: 180px;overflow-y: auto;">
            <div class="col-xs-12">
                <div class="portlet light" style="padding-bottom: 0;margin-bottom: 0;">
                    <h4><b>Características dos cômodos</b></h4>
                </div>
            </div>
            <div class="col-xs-12" style="margin: 0 0 10px 0;" v-for="room in construction.rooms">
                <div class="portlet light" style="padding-bottom: 0;margin-bottom: 10px;">
                    <h5><b>{{ room.type.name }} <span v-if="room.name" style="font-size: 11px;">({{ room.name }})</span></b></h5>
                    <div class="col-xs-12" v-if="room.features.length">
                        {{ featuresList(room.features) }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>


// WEBPACK FOOTER //
// ConstructionFeaturesTab.vue?299574d6